export const actions = {
  setShowSuccessModal: 'set_show_success_modal',
  setShowSaveModal: 'set_show_save_modal',
  setSwitchStatus: 'set_switch_status',
  setShowScheduleMessageModal: 'set_show_schedule_message_modal',
  setShowErrors: 'set_show_errors',
  updateErrorContainer: 'update_error_container',
  updateStepErrorArray: 'update_step_error_array',
  resetStepErrorArray: 'reset_step_error_array',
  resetErrorContainer: 'reset_error_container',
};

const sideBarInitialState = {
  showSuccessModal: false,
  showSaveModal: false,
  switchStatus: true,
  showScheduleMessageModal: false,
  showErrors: false,
  errorContainer: [],
  stepErrorArray: {
    firstStep: false,
    secondStep: false,
    thirdStep: false,
  },
};

function sideBarReducer(state, action) {
  switch (action.type) {
    case actions.setShowSuccessModal: {
      const { payload } = action;
      return {
        ...state,
        showSuccessModal: payload,
      };
    }
    case actions.setShowSaveModal: {
      const { payload } = action;
      return {
        ...state,
        showSaveModal: payload,
      };
    }
    case actions.setSwitchStatus: {
      const { payload } = action;
      return {
        ...state,
        switchStatus: payload,
      };
    }
    case actions.setShowScheduleMessageModal: {
      const { payload } = action;
      return {
        ...state,
        showScheduleMessageModal: payload,
      };
    }
    case actions.setShowErrors: {
      const { payload } = action;
      return {
        ...state,
        showErrors: payload,
      };
    }
    case actions.updateErrorContainer: {
      const { payload } = action;
      return {
        ...state,
        errorContainer: [...payload],
      };
    }
    case actions.resetErrorContainer: {
      return {
        ...state,
        errorContainer: [],
      };
    }
    case actions.updateStepErrorArray: {
      const { payload } = action;
      return {
        ...state,
        stepErrorArray: { ...state.stepErrorArray, ...payload },
      };
    }
    case actions.resetStepErrorArray: {
      return {
        ...state,
        stepErrorArray: {
          ...state.stepErrorArray,
          firstStep: false,
          secondStep: false,
          thirdStep: false,
        },
      };
    }
    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}

export { sideBarReducer, sideBarInitialState };
